import assert from 'shared/utils/assert'
import { validate } from './helpers/pznValidator'
import BackendAPIService from './BackendAPIService'

class ProductRatingService extends BackendAPIService {
  getProductRatingsPath(id) {
    const { pzn } = validate(id)
    return `/cacheable/${this.language}/ratings/${this.apiVersion}/${this.tenantPath}/product/${pzn}`
  }

  async fetchProductRatings(id, params = null) {
    assert(
      id,
      'ProductRatingService.fetchProductRatings: please provide an "id"'
    )
    this.logger.debug(`Fetching ProductRatings ${id}`, 'dataFetching')
    let response
    if (params) {
      response = await this.get(this.getProductRatingsPath(id), { params })
    } else {
      response = await this.get(this.getProductRatingsPath(id))
    }
    this.logger.debug(`ProductRatings ${id} fetched!`, 'dataFetching')
    return response
  }
}

export default ProductRatingService
